import { createFileRoute } from '@tanstack/react-router'
import { PurchaseOrderDetailPage } from '@/pages/purchase-order-detail'

type POSearchParams = {
  tab?: string
  /** A conversation to open, by thread UUID (links from the project page). */
  thread?: string
  /** An action item to scroll to and highlight (links from the Action Items page). */
  action?: string
  /** An email to open and highlight, by message id (an action item's link to its source email). */
  message?: string
}

export const Route = createFileRoute('/_authenticated/purchase-orders/$poId')({
  staticData: { title: 'Purchase Order' },
  component: PurchaseOrderDetailRoute,
  validateSearch: (search: Record<string, unknown>): POSearchParams => ({
    tab: typeof search.tab === 'string' ? search.tab : undefined,
    thread: typeof search.thread === 'string' ? search.thread : undefined,
    action: typeof search.action === 'string' ? search.action : undefined,
    message:
      typeof search.message === 'string' || typeof search.message === 'number'
        ? String(search.message)
        : undefined,
  }),
})

function PurchaseOrderDetailRoute() {
  const { poId } = Route.useParams()
  const { tab, thread, action, message } = Route.useSearch()
  const messageId = message ? Number(message) : undefined
  return (
    <PurchaseOrderDetailPage
      poId={poId}
      tab={tab}
      threadUuid={thread}
      actionUuid={action}
      messageId={Number.isInteger(messageId) ? messageId : undefined}
    />
  )
}
